"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function IconButton({ onClick, icon, iconSize, ...rest }) {
    const Icon = icon;
    return (react_1.default.createElement(style_1.StyledIconButton, { onClick: onClick, ...rest },
        react_1.default.createElement(Icon, { style: { fontSize: iconSize } })));
}
exports.default = IconButton;
